module.exports = __webpack_public_path__ + "assets/img/Type BS (18).1fe45706.jpg";